import React from "react";
import Header from "../../component/users/Header";
import { useSelector } from "react-redux";
import {
  FormControl,
  InputLabel,
  TextField,
  Button,
  Backdrop,
  CircularProgress,
  Box,
  Typography,
  Checkbox,
  Link,
  FormHelperText,
  FormControlLabel,
  InputAdornment,
  IconButton,
  Container,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import HomeSkeleton from "../../component/users/Home/Skeleton";
import Footer from "../../component/users/Footer";
import LeaderboardComponent from "../../component/users/Leaderboard";
import LeaderboardSkeleton from "../../component/users/Leaderboard/Skeleton";

const Leaderboards = () => {
  const user = useSelector((state) => state.user.loading);
  return (
    <>
      <Header />
      {user ? (
        <LeaderboardSkeleton />
      ) : (
        <Box className="userLayout">
          <Container
            disableGutters={true}
            maxWidth="lg"
            sx={{
              background: "#242743",
              paddingBottom: "0px",
              // minHeight: "calc(100% - 56px)",
            }}
          >
            <LeaderboardComponent />
            <Footer />
          </Container>
        </Box>
      )}
    </>
  );
};

export default Leaderboards;
